import { createRouter, createWebHistory } from 'vue-router';
import { SecRouteConfig } from '@/router/utils';
import { RouteName } from '@/enums/routing';
import projectsRoutes from '@/router/projects/routes';
import setupRoutes from '@/router/setup/routes';
import adminRoutes from '@/router/admin/routes';
import launchpadRoutes from '@/router/launchpad/routes';
import { useAuth0 } from '@auth0/auth0-vue';
import { watch } from 'vue';

const routes: SecRouteConfig[] = [
  {
    path: '/',
    name: RouteName.Root,
    redirect: (to) => ({ path: '/launchpad', query: to.query }),
  },
  ...launchpadRoutes,
  ...projectsRoutes,
  ...setupRoutes,
  ...adminRoutes,
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: RouteName.Root },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  if (to.path === '/callback') {
    return true; // allow the callback route through
  }

  if (isLoading.value) {
    await new Promise<void>((resolve) => {
      const stop = watch(isLoading, (loaded: boolean) => {
        if (!loaded) {
          stop();
          resolve();
        }
      });
    });
  }

  if (!isAuthenticated.value) {
    const invitation = to.query.invitation as string | undefined;
    const organization = to.query.organization as string | undefined;

    const options: Parameters<typeof loginWithRedirect>[0] = {
      appState: { target: to.fullPath },
    };

    if (invitation && organization) {
      options.authorizationParams = {
        invitation,
        organization,
      };
    }

    await loginWithRedirect(options);

    // Cancel the current navigation because we’re leaving the app for Auth0
    return false;
  }

  return true; // allow navigation
});

export default router;
